import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryServiceType as LinkDeliveryServiceType } from '../links/DeliveryServiceType';
import { type CancelWarehouseDeliveryIntakeReq as SchemaCancelWarehouseDeliveryIntakeReq } from '../schemas/CancelWarehouseDeliveryIntakeReq';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Отменить забор для склада
 */
export const CancelWarehouseDeliveryIntakeContentType = 'application/json' as const;
export type CancelWarehouseDeliveryIntakeRequest = SchemaCancelWarehouseDeliveryIntakeReq;
export type CancelWarehouseDeliveryIntakeResponses = LinkCommonErrorResponses & {};
export type CancelWarehouseDeliveryIntakeResponseSuccess = undefined;
export type CancelWarehouseDeliveryIntakeSearchParams = {
    service_type: LinkDeliveryServiceType;
};
export type CancelWarehouseDeliveryIntakePathParameters = {
    warehouse_id: string;
};
export const CancelWarehouseDeliveryIntakeUrl = '/warehouses/{warehouse_id}/intake/cancel' as const;
export const CancelWarehouseDeliveryIntakeMethod = 'POST' as const;
export const getCancelWarehouseDeliveryIntakeUrl = (params: CancelWarehouseDeliveryIntakePathParameters) =>
    CancelWarehouseDeliveryIntakeUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof CancelWarehouseDeliveryIntakePathParameters) => String(params[param])
    );
